import { render, staticRenderFns } from "./GuiasDocumentosVentaEnviarPerseo.vue?vue&type=template&id=10963bbe&scoped=true"
import script from "./GuiasDocumentosVentaEnviarPerseo.vue?vue&type=script&lang=js"
export * from "./GuiasDocumentosVentaEnviarPerseo.vue?vue&type=script&lang=js"
import style0 from "./GuiasDocumentosVentaEnviarPerseo.vue?vue&type=style&index=0&id=10963bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10963bbe",
  null
  
)

export default component.exports